import { formatPhoneNumber as format } from 'react-phone-number-input'

export const formatPhoneNumber = number => {
  return format(number) || number
}

export const formatPhoneNumberForDisplay = number => {
  if (!number) return undefined

  const normalized = String(number).trim()
  if (normalized.startsWith('+')) {
    return format(normalized) || normalized
  }

  const digits = normalized.replace(/\D/g, '')
  if (digits.length === 10) {
    return format(`+1${digits}`) || normalized
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return format(`+${digits}`) || normalized
  }

  return format(normalized) || normalized
}

// removes +1 from phone number if it exists
export const stripPhoneNumber = phoneNumber => {
  if (phoneNumber?.startsWith('+1')) {
    phoneNumber = phoneNumber.substring(2)
  }
  return phoneNumber
}
